import React from 'react';

import style from './OmrMemberSummaryReadOnly.module.css';
import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OmrMemberSummaryReadOnly = ({ label, name, value, className }) => (
  <div className={global.ComponentFlex}>
    <label className={style.ReadOnlyLabel} htmlFor={name}>{label}</label>
    <div>
      <input
        className={className}
        type="hidden"
        value={value}
        id={name}
        name={name} />
      <span className={style.ReadOnlyValue}>{value || <span>&nbsp;</span>}</span>
    </div>
  </div>
);

export default OmrMemberSummaryReadOnly;